export const GEM_BID_LIST= "GEM_BID_LIST";
export const GEM_ENABLE_FILTER_LIST= "GEM_ENABLE_FILTER_LIST";
export const INSERT_FILTER= "INSERT_FILTER";
export const MINISTRY_LIST= "MINISTRY_LIST";
export const ORGANIZATION_LIST= "ORGANIZATION_LIST";
export const ADD_BID_TO_FAVOURITE= "ADD_BID_TO_FAVOURITE";
export const PENDING_GEM_BID_LIST= "PENDING_GEM_BID_LIST";
export const COMPLETED_GEM_BID_LIST= "COMPLETED_GEM_BID_LIST";
export const ADD_GEM_BID_DATA_DETAILS= "ADD_GEM_BID_DATA_DETAILS";
export const GEM_BID_DATA_DONE= "GEM_BID_DATA_DONE";
